import type { DriveStep } from 'driver.js';

const at = (id: string) => `[data-tour="${id}"]`;

/** "Tour this page" for SEO Autopilot (/autopilot). Anchors live in AutopilotPage.tsx. */
export function getAutopilotTourSteps(): DriveStep[] {
  return [
    {
      popover: {
        title: 'SEO Autopilot',
        description:
          'Autopilot keeps working on your site while you sell: it queues fixes every day, drafts ' +
          'a blog post every week and emails you a report every month. It is included on Brokerage ' +
          'Growth and is an add-on for Agent IDX Growth.',
      },
    },
    {
      element: at('autopilot-switch'),
      popover: {
        title: 'Turn it on or off',
        description: 'Flip this switch to start or pause Autopilot. When it is off, nothing new is drafted.',
        side: 'bottom',
        align: 'end',
      },
    },
    {
      element: at('autopilot-mode'),
      popover: {
        title: 'Ask first, or let it apply',
        description:
          '“Ask me first” keeps every change in your inbox until you approve it. “Apply on its own” ' +
          'puts titles, descriptions and weekly posts live as they are drafted — you can undo any of ' +
          'them for 90 days.',
        side: 'bottom',
        align: 'start',
      },
    },
    {
      element: at('autopilot-budget'),
      popover: {
        title: 'Monthly budget',
        description:
          'The most Autopilot may spend each month. It shows what has been spent so far, and ' +
          'Autopilot stops drafting when the budget is used up.',
        side: 'top',
        align: 'start',
      },
    },
    {
      element: at('autopilot-inbox'),
      popover: {
        title: 'Your inbox',
        description:
          'Each card is one thing Autopilot wants to change — a search title and description, a ' +
          'blog post, a fix, or a directory listing to claim. Nothing touches your site until you ' +
          'click a button on it.',
        side: 'bottom',
        align: 'start',
      },
    },
    {
      element: at('autopilot-history'),
      popover: {
        title: 'History',
        description: 'See what went live. Changed your mind? Click Undo to put something back.',
        side: 'bottom',
        align: 'start',
      },
    },
    {
      element: at('autopilot-run-now'),
      popover: {
        title: 'Run now',
        description:
          'Run Autopilot straight away instead of waiting for its schedule (at most once every ' +
          '10 minutes). It works once Autopilot is on.',
        side: 'bottom',
        align: 'end',
      },
    },
  ];
}
